<script lang="ts">
    import { _, locale, locales } from "svelte-i18n";
    import {
        ButtonDropdown,
        DropdownItem,
        DropdownMenu,
        DropdownToggle,
    } from "sveltestrap";
    let selectedLanguage = $locale;
    let textClass: string = "";
    export { textClass as text };
    export let color = "dark";

    // try to recover settings from local storage first.
    // if that fails use the already sected language from browser settings.
    if (
        typeof window !== "undefined" &&
        window.localStorage.getItem("lang") !== null
    ) {
        selectedLanguage = window.localStorage.getItem("lang");
        locale.set(selectedLanguage);
        console.log("language set from local storage");
    } else {
        // try to match to one of the supported languages.
        let i = $locales.findIndex(
            (x) => selectedLanguage.substring(0, 2) === x
        );
        if (i === -1) {
            console.log("language not found, defaulting to en");
            selectedLanguage = $locales[0];
        } else {
            console.log("a match was found");
            selectedLanguage = $locales[i];
        }
        locale.set(selectedLanguage);
    }

    function setLocale(ln: string) {
        selectedLanguage = ln;

        locale.set(selectedLanguage);

        if (
            typeof window !== "undefined"
        ) {
            window.localStorage.setItem('lang', selectedLanguage);
            console.log("language set to local storage");
        }

        try {
            console.log(selectedLanguage);
            document.title = $_("title");
        } catch (e) {
            console.error(e);
            // Not yet inited
        }
    }
</script>

<ButtonDropdown nav inNavbar class="ms-1">
    <DropdownToggle class="btn-sm text-sm {textClass}" color="{color}" caret
        >{selectedLanguage}</DropdownToggle>
    <DropdownMenu
        class="no-transitions"
        style="z-index: 1070; min-width: 5rem;">
        {#each $locales as ln}
            <DropdownItem on:click={() => setLocale(ln)}
                >{ln}</DropdownItem>
        {/each}
    </DropdownMenu>
</ButtonDropdown>

<style>
    .no-transitions {
        transition: none;
    }
</style>
